// eslint-disable-next-line func-style
function createStarpayActionFilter(starpayActionType) {
  return function (paymentInstruments) {
    if (!Array.isArray(paymentInstruments)) {
      return [];
    }
    return paymentInstruments
      .filter((pi) => {
        if (!pi?.starpayActions || !Array.isArray(pi.starpayActions)) {
          return false;
        }
        return pi.starpayActions.find((sa) => sa.type === starpayActionType);
      })
      .sort((a, b) => {
        const aAction = a?.starpayActions?.find(
          (action) => action.type === starpayActionType
        );
        const bAction = b?.starpayActions?.find(
          (action) => action.type === starpayActionType
        );
        return aAction?.sortOrderIndex - bAction?.sortOrderIndex;
      })
      .filter(Boolean);
  };
}

export const filterByMOPActionType = createStarpayActionFilter('MOP');

export const filterByGiftActionType = createStarpayActionFilter('GIFT');

export const filterByReloadActionType = createStarpayActionFilter('RELOAD');

export const filterByManageActionType = createStarpayActionFilter('MANAGE');

export const filterByAutoReloadActionType =
  createStarpayActionFilter('AUTORELOAD');
